import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space[4]};
  padding: ${space[4]} 0;
  border-bottom: 1px solid ${colors.borderGreyLighter};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space[4]};
  min-width: 0;
  flex: 1;
`;

export const Thumbnail = styled.div`
  width: 64px;
  height: 64px;
  border-radius: ${layout.borderRadiusMd};
  overflow: hidden;
  flex-shrink: 0;
  background: ${colors.lighterGrey};
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.lightGrey};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  line-height: 1.3;
`;

export const MetaLine = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
  line-height: 1.4;
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
  text-align: right;
`;

export const PriceAmount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  white-space: nowrap;
`;

export const PriceNote = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
  white-space: nowrap;
`;
